import { Component, OnInit, OnDestroy, ViewEncapsulation, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NgForm } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-new-investment',
  templateUrl: './new-investment.component.html',
  styleUrls: ['./new-investment.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewInvestmentComponent implements OnInit, OnDestroy {

  // Typing animation variables
  words: string[] = ['SIP', 'Insurance', 'Portfolio Review', 'Retirement Plan', 'Wealth Creation'];
  typedText: string = '';
  wordIndex: number = 0;
  isDeleting: boolean = false;
  typingTimeout: any;

  name: string = "";
  email: string = "";
  mobile: string = "";
  pincode: string = "";

  nameValidateMessage: string = '';
  emailValidateMessage: string = '';
  mobileValidateMessage: string = '';
  pinValidateMessage: string = '';

  isModalVisible: boolean = false;
  isLeadFormVisible: boolean = true;
  isOtpFormVisible: boolean = false;
  isThanksVisible: boolean = false;

  userOTP: string = "";
  otpValidateMessage: string = '';
  otpVerifiedStatus: boolean = true;

  intervalId: any;
  timeleft: number = 0;
  isTimer: boolean = true;
  isResend: boolean = false;
  clickedResend: number = 0;
  resendBtnTimer = 3;

  visitorId: any;
  leadId: string = '';
  visitortype: string = 'campaign-new-investment';
  pincodeArr: any[] = [];
  hideSuggestion: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    private service: DataService,
    private titleService: Title,
    private metaService: Meta,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    if (sessionStorage.getItem('visitorId')) {
      this.visitorId = '';
      sessionStorage.setItem('visitorId', '');
    }
    if (sessionStorage.getItem('leadId')) {
      this.leadId = '';
      sessionStorage.removeItem('leadId');
    }
    this.createVisitor();
    this.metaForSEO('new-investment-landing');
    this.typeWords();
  }

  ngOnDestroy(): void {
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }
  }

  typeWords() {
    const currentWord = this.words[this.wordIndex];
    
    if (this.isDeleting) {
      this.typedText = currentWord.substring(0, this.typedText.length - 1);
    } else {
      this.typedText = currentWord.substring(0, this.typedText.length + 1);
    }

    let typeSpeed = 150;

    if (this.isDeleting) {
      typeSpeed /= 2; // erase faster
    }

    if (!this.isDeleting && this.typedText === currentWord) {
      typeSpeed = 1500; // pause at full word
      this.isDeleting = true;
    } else if (this.isDeleting && this.typedText === '') {
      this.isDeleting = false;
      this.wordIndex = (this.wordIndex + 1) % this.words.length;
      typeSpeed = 500; // pause before typing next word
    }

    this.typingTimeout = setTimeout(() => {
      this.typeWords();
    }, typeSpeed);
  }

  private fireGoogleAdsConversion(sendTo: string): void {
    const gtag = (window as any).gtag;
    if (typeof gtag === 'function') {
      gtag('event', 'conversion', { 'send_to': sendTo });
      return;
    }

    const dataLayer = (window as any).dataLayer = (window as any).dataLayer || [];
    dataLayer.push(['event', 'conversion', { 'send_to': sendTo }]);
  }

  metaForSEO(slugname: string): void {
    this.service.getDynamicMeta().subscribe(
      (data: any) => {
        const seoPages = data?.rows?.[0]?.seo_pages || [];
        seoPages.forEach((v: any) => {
          if (v.seo_slug === slugname || v.seo_slug === "/" + slugname) {
            this.titleService.setTitle(v.seo_title || 'New Investment - Bajaj Capital');
            this.metaService.removeTag('name="keywords"');
            this.metaService.removeTag('name="description"');
            this.metaService.addTags([
              { name: 'keywords', content: v.seo_keywords || 'Investment, Bajaj Capital' },
              { name: 'description', content: v.seo_description || 'Get expert guidance before making your next financial decision.' },
              { name: 'robots', content: 'index, follow' }
            ]);
          }
        });
      },
      (err) => {
        this.titleService.setTitle('New Investment - Bajaj Capital');
        this.metaService.addTags([
          { name: 'description', content: 'Get expert guidance before making your next financial decision.' },
          { name: 'robots', content: 'index, follow' }
        ]);
      }
    );
  }

  createVisitor() {
    let jscd = window['jscd'];
    if (!sessionStorage.getItem('visitorId')) {
      let obj = {
        "browsername": jscd?.browser,
        "browserversion": jscd?.browser + ' ' + jscd?.browserVersion,
        "operatingsystem": jscd?.os + " " + jscd?.osVersion,
        "device": jscd?.os,
        "sourceurl": window.location.href,
        "productid": '44',
        "visitortype": this.visitortype,
        "utmsource": this.GetParameterValues("utm_source"),
        "utmmedium": this.GetParameterValues("utm_medium"),
        "leadsource": this.GetParameterValues("lead_source"),
        "utmcampaign": this.GetParameterValues("utm_campaign"),
      };
      this.service.createVisitor(obj).subscribe((data: any) => {
        this.visitorId = data["visitorId"];
        sessionStorage.setItem('visitorId', data["visitorId"]);
      }, err => {
        console.log(err);
      });
    } else {
      this.visitorId = sessionStorage.getItem('visitorId');
    }
  }

  openExpertLeadModal(): void {
    this.fireGoogleAdsConversion('AW-18261612633/bWobCKbTndAcENmw6INE');
    this.openLeadModal();
  }

  openLeadModal() {
    this.isModalVisible = true;
    this.isLeadFormVisible = true;
    this.isOtpFormVisible = false;
    this.isThanksVisible = false;
  }

  closeLeadModal() {
    this.isModalVisible = false;
  }

  PostData(leadForm: NgForm) {
    if (!this.checkValidationMsg(leadForm)) {
      return;
    }
    this.createLead();
    this.isLeadFormVisible = false;
    this.isOtpFormVisible = true;
    this.isThanksVisible = false;
    this.isTimer = true;
    this.startTimer();
  }

  createLead() {
    let leadid = sessionStorage.getItem('leadId');
    this.visitorId = sessionStorage.getItem('visitorId');
    let obj = {
      "visitorid": this.visitorId,
      "leadid": leadid ? leadid : 0,
      "name": this.name,
      "mobile": this.mobile,
      "email": this.email,
      "pincode": this.pincode
    };
    this.service.createLead(obj).subscribe((data: any) => {
      sessionStorage.setItem('leadId', data['leadid']);
      this.leadId = data['leadid'];
      this.sendOtp();
    }, err => {
      console.log(err);
    });
  }

  sendOtp() {
    this.service.sendOtp({ leadid: this.leadId, mobile: this.mobile }).subscribe(data => {
      console.log("OTP Sent");
    }, err => {
      console.log(err);
    });
  }

  SubmitOTP(otpForm: NgForm) {
    this.userOTP = otpForm.value.otp;
    if (this.userOTP) {
      if (this.userOTP.length === 6) {
        this.VerifyOTP();
      } else {
        this.otpValidateMessage = "lengthError";
      }
    } else {
      this.otpValidateMessage = "required";
    }
  }

  VerifyOTP() {
    $("#otp_verify_btn").attr("disabled", "true");
    this.service.verifyOtp({ leadid: this.leadId, otp: this.userOTP }).subscribe(data => {
      if (data["success"]) {
        $("#otp_verify_btn").removeAttr("disabled");
        sessionStorage.removeItem('leadId');
        sessionStorage.setItem('formSubmitted', 'true');
        this.isThanksVisible = true;
        this.isOtpFormVisible = false;

        let utm_source = this.GetParameterValues("utm_source");
        let utm_medium = this.GetParameterValues("utm_medium");
        let lead_source = this.GetParameterValues("lead_source");
        let utm_campaign = this.GetParameterValues("utm_campaign");

        this.service.pushLeadToLSQ({
          visitor_type: this.visitortype,
          Name: this.name,
          Mobile: this.mobile,
          Email: this.email,
          Campaign_Name: 'New_Investment_Campaign',
          Landing_Page_URL: window.location.href,
          LEADID: this.leadId,
          Pincode: this.pincode,
          Product: "Financial Planning",
          Sub_LeadSource: utm_source ? utm_source : "",
          Utm_Source: utm_source ? utm_source : 'Websites',
          Utm_Medium: utm_medium ? utm_medium : '',
          Utm_Campaign: utm_campaign ? utm_campaign : '',
          LeadSource: 'Digital Marketing',
          Entity_Type: 'Digital_BCL',
        }).subscribe((res: any) => {
          console.log("LSQ pushed", res);
        });
        this.leadId = '';
      } else {
        $("#otp_verify_btn").removeAttr("disabled");
        this.otpVerifiedStatus = false;
      }
    }, err => {
      $("#otp_verify_btn").removeAttr("disabled");
      console.log(err);
    });
  }

  startTimer() {
    clearInterval(this.intervalId);
    this.otpVerifiedStatus = true;
    this.timeleft = 20;
    this.timeleft -= 1;
    this.intervalId = setInterval(() => {
      if (this.timeleft == 0 && this.isOtpFormVisible == true) {
        if (this.clickedResend === this.resendBtnTimer) {
          this.isResend = false;
        }
        if (this.clickedResend > 0 && this.clickedResend < this.resendBtnTimer) {
          this.isResend = true;
        }
        this.isTimer = false;
        clearInterval(this.intervalId);
        if (this.clickedResend == 0) {
          this.isResend = true;
        }
      }
      this.timeleft -= 1;
    }, 1000);
  }

  resendOTP() {
    $("#otp_verify_btn").removeAttr("disabled");
    this.userOTP = "";
    this.clickedResend++;
    this.sendOtp();
    this.startTimer();
    this.isTimer = true;
    this.isResend = false;
  }

  changeNumber() {
    $("#otp_verify_btn").removeAttr("disabled");
    this.userOTP = "";
    this.clickedResend = 0;
    this.isResend = false;
    this.isTimer = false;
    this.isLeadFormVisible = true;
    this.isOtpFormVisible = false;
    this.mobile = "";
  }

  removeErrorMsg(fieldname: string) {
    if (fieldname == "otp") {
      this.otpValidateMessage = "";
      this.otpVerifiedStatus = true;
    }
    if (fieldname == "name") {
      this.nameValidateMessage = "";
    }
    if (fieldname == "email") {
      this.emailValidateMessage = "";
    }
    if (fieldname == "mobile") {
      this.mobileValidateMessage = "";
    }
    if (fieldname == "pincode") {
      this.pinValidateMessage = "";
    }
  }

  checkValidationMsg(leadForm: NgForm) {
    let num: number = 0;
    this.name = (leadForm.value.name || '').trim();
    this.email = (leadForm.value.email || '').trim();
    this.mobile = (leadForm.value.mobile || '').trim();
    this.pincode = (leadForm.value.pincode || '').trim();

    if (this.name && this.name.length < 3) {
      this.nameValidateMessage = "lengthError";
      num += 1;
    }
    if (!this.name) {
      this.nameValidateMessage = "required";
      num += 1;
    }
    if (this.email && this.validateEmailAddress(this.email) == 0) {
      this.emailValidateMessage = "invalid";
      num += 1;
    }
    if (!this.email) {
      this.emailValidateMessage = "required";
      num += 1;
    }
    if (this.isMobileWrong(this.mobile) == 0) {
      this.mobileValidateMessage = "invalid";
      num += 1;
    }
    if (!this.mobile) {
      this.mobileValidateMessage = "required";
      num += 1;
    }
    if (this.mobile && this.mobile.length != 10) {
      this.mobileValidateMessage = "lengthError";
      num += 1;
    }
    if (!this.pincode) {
      this.pinValidateMessage = "required";
      num += 1;
    }
    if (this.pincode && this.pincode.length != 6) {
      this.pinValidateMessage = "invalid";
      num += 1;
    }

    return num === 0;
  }

  validateEmailAddress(email: string) {
    if (email) {
      var lastChars = email.lastIndexOf(".");
      var expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
      if (!expression.test(String(email).toLowerCase()) || email.substring(lastChars, 3).length < 3) {
        return 0;
      } else {
        return 1;
      }
    }
    return 0;
  }

  isMobileWrong(mobile: string) {
    let firstDigit = mobile.substring(0, 1);
    if (firstDigit != '6' && firstDigit != '7' && firstDigit != '8' && firstDigit != '9') {
      return 0;
    } else if (mobile.match(/^(\d)\1+$/g)) {
      return 0;
    } else {
      return 1;
    }
  }

  openSuggestionBox(event: Event, flag: string) {
    const target = event.target as HTMLInputElement | null;
    if (target && target.value.length > 0) {
      this.hideSuggestion = true;
    }
  }

  hideSuggestionDiv(flag: string) {
    setTimeout(() => {
      this.hideSuggestion = false;
      if (this.pincode) {
        this.pinValidateMessage = "";
      }
    }, 200);
  }

  getPincodeList(event: Event, flag: string) {
    const pincode = (event.target as HTMLInputElement).value;
    if (pincode.length <= 3) {
      this.hideSuggestion = false;
    }
    this.service.cityFiler(pincode).subscribe((response: any) => {
      if (pincode.length > 3) {
        this.hideSuggestion = true;
        this.pincodeArr = response['data'] || [];
        if (this.pincodeArr.length === 0) {
          this.pinValidateMessage = "invalid";
        }
      }
    });
  }

  setpincode(pinObj: any, flag: string) {
    this.pincode = pinObj.pincode;
    this.hideSuggestion = false;
  }

  alphaOnly(event: any) {
    var key = event.keyCode;
    return ((key >= 65 && key <= 90) || (key == 8 || key == 32));
  }

  numbersOnly($event: any) {
    if ($event.target.value.length === 0) {
      if ($event.key === '0' || $event.key === '1' || $event.key === '2' || $event.key === '3' || $event.key === '4' || $event.key === '5') {
        return false;
      }
    }
    var reg = /^[0-9]+$/;
    return (reg.test($event.key));
  }

  numberspincode($event: any) {
    if ($event.target.value.length === 0) {
      if ($event.key === '0') {
        return false;
      }
    }
    var reg = /^[0-9]+$/;
    return (reg.test($event.key));
  }

  GetParameterValues(param: string) {
    var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < url.length; i++) {
      var urlparam = url[i].split('=');
      if (urlparam[0] == param) {
        return urlparam[1];
      }
    }
    return "";
  }
}
